import styled from "styled-components"
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext"
import Tabela from "../../../Componentes/Utils/Tabela"
import ModalEditItens from "./ModalEditItens"
import axios from "axios"
import { useEffect, useState } from "react"

import { MdEdit } from "react-icons/md";
import { GoTrash } from "react-icons/go";
import ModalDeleteItem from "./ModalDeleteItem"

const BotaoAddItem = styled.button`
    width: 200px;
    height: 40px;
    background-color: #4CAF50;
    color: white;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    transition: .3s;
    &:hover {
        background-color: #45a049;
        scale: 1.05;
    }
    margin-left: auto;
    margin-bottom: 10px;
`
const ColunaTabela = styled.td`
    color: #000;
`
const ColunaAcoes = styled.td`
    width: 120px;
`
const DivAcoes = styled.div`
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`
const IconeEdit = styled(MdEdit)`
    width: 22px;
    height: 22px;
    color: #0000ff;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.1;
    }
`
const IconeApagar = styled(GoTrash)`
    width: 20px;
    height: 20px;
    color: #ff0000;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.1;
    }
`


const ModalListaItens = ({ origem, id_tipo, id_modelo }) => {

    const { closeModal, openModal, isModalOpen } = useModal();

    const [selectedItem, setSelectedItem] = useState(null);

    const openNewItem = (item = null) => {

        setSelectedItem(item);
        openModal('editItem');

    }

    const closeNewItem = () => {

        setSelectedItem(null);
        closeModal();

    }

    const openDeleteItem = ( item ) => {

        setSelectedItem(item);
        openModal('deleteItem');

    }

    const [listaItens, setListaItens] = useState([])

    const fetchItens = async () => {
        try {
            const { data } = await axios.get(
                `https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetItens/index.php?idTipo=${id_tipo}${id_modelo ? `&idModelo=${id_modelo}` : ""}`,
                { withCredentials: true }
            );

            setListaItens(data);

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchItens();
    }, [])

    return (
        <>
            <Overlay state={true} >
                <Modal size="lg" header={true} close={closeModal} >
                    <BotaoAddItem onClick={() => openNewItem()} >NOVO ITEM</BotaoAddItem>
                    <Tabela>
                        <thead>
                            <tr>
                                <th colSpan={2} >ITEM</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listaItens.map((obj) => (
                                <tr key={obj.id} >
                                    <ColunaTabela>{obj.item}</ColunaTabela>
                                    <ColunaAcoes>
                                        <DivAcoes>
                                            <IconeEdit onClick={() => openNewItem(obj)} />
                                            <IconeApagar onClick={() => openDeleteItem(obj)} />
                                        </DivAcoes>
                                    </ColunaAcoes>
                                </tr>
                            ))}
                        </tbody>
                    </Tabela>
                </Modal>
            </Overlay>
            {isModalOpen('editItem') && (
                <ModalEditItens
                    id_tipo={id_tipo}
                    id_modelo={id_modelo ? id_modelo : null}
                    fetchSuccess={fetchItens}
                    fecharModal={closeNewItem}
                    itemSelected={selectedItem}
                />
            )}
            {isModalOpen('deleteItem') && (
                <ModalDeleteItem
                    fetchSuccess={fetchItens}
                    fecharModal={closeNewItem}
                    itemSelected={selectedItem}
                />
            )}
        </>
    )
}

export default ModalListaItens;